/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Device_Approved_BodyInputs */



/**
* | output |
* | --- |
* | "Access approved. Return to the app - you can close this tab." |
*
* @param {Auth_Device_Approved_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_device_approved_body = /** @type {((inputs?: Auth_Device_Approved_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Device_Approved_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zugriff genehmigt. Kehre zur App zurück - du kannst diesen Tab schließen.")
	return /** @type {LocalizedString} */ ("Access approved. Return to the app - you can close this tab.")
});